"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filtr = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Filtr = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  background: black;\n  color: white;\n  padding: 3px 6px;\n  border-radius: 3px;\n  margin-top: 10px;\n  margin-right: 20px;\n"], ["\n  display: inline-block;\n  background: black;\n  color: white;\n  padding: 3px 6px;\n  border-radius: 3px;\n  margin-top: 10px;\n  margin-right: 20px;\n"])));
var templateObject_1;
